module.exports = __webpack_public_path__ + "media/images/themes/light/epic-games-be3490fff70c621fb5ea6236582f875b.svg";